import { useState, useEffect, useSelector, useDispatch } from './basic'
import { fetchCities, fetchRegions, searchCities } from 'store/actions'
import { REGIONAL_COUNTRIES } from 'common/constants'
import { nativeSetValue } from 'utils'

const calculateGeo = (countryIds = [], regionIds = [], cityIds = []) => {
  const countryId = countryIds.length == 1 && countryIds[0]
  const regionId = regionIds.length == 1 && regionIds[0]
  const isRegional = REGIONAL_COUNTRIES.includes(+countryId)
  const citySelector = countryId + (isRegional ? `.${regionId}` : '')
  const showCities = isRegional ? regionId : countryId

  regionIds = countryId ? regionIds : []
  cityIds = showCities ? cityIds : []

  return { countryIds, regionIds, cityIds, countryId, regionId, citySelector, isRegional, showCities }
}

const useGeo = () => {
  const geo = useSelector(s => s.geo)
  const md = useSelector(s => s.myProfile.matchDescriptor)
  const dispatch = useDispatch()
  const [selected, setSelected] = useState(calculateGeo(md.lfCountryIds, md.lfRegionIds, md.lfCityIds))

  const regions = geo.regions[selected.countryId] || []
  const cities = geo.cities[selected.citySelector] || []
  const countries = useSelector(s => s.registry.countries)
  const onCountryChange = e => setSelected(calculateGeo(e.target.value.split(',')))
  const onRegionChange = e => setSelected(calculateGeo(selected.countryIds, e.target.value.split(',')))

  useEffect(() => {
    const { isRegional, showCities, countryId, citySelector, regionId } = selected

    isRegional && countryId && !geo.regions[countryId] && dispatch(fetchRegions(countryId))
    showCities && !geo.cities[citySelector] && dispatch(fetchCities({ countryId, regionId }))
  }, [selected])

  return {
    countries: { options: countries, selected: selected.countryIds, onChange: onCountryChange },
    regions: { options: regions, selected: selected.regionIds, onChange: onRegionChange },
    cities: { options: cities, selected: selected.cityIds },
  }
}

const useSimpleGeo = (locationInfo, showCapital) => {
  const dispatch = useDispatch()
  const [countryId, setCountryId] = useState(locationInfo.country?.id)
  const [regionId, setRegionId] = useState(locationInfo.region?.id || '')
  const [cityId, setCityId] = useState(locationInfo.city?.id || '')
  const [citySearch, setCitySearch] = useState(locationInfo.city?.name || '')

  const country = {
    options: useSelector(s => s.registry.countries),
    selected: [countryId],
    onChange: e => {
      const { capitalId, capitalName, capitalRegionId } = country.options.find(c => c.id == e.target.value)
      setCountryId(e.target.value)
      setCityId(showCapital ? capitalId : '')
      setRegionId(showCapital ? capitalRegionId || 0 : '')
      setCitySearch(showCapital ? capitalName : '')
    },
  }

  const region = { value: regionId }

  const search = cityName => cityName.length > 2 && dispatch(searchCities(countryId, cityName))
  const cities = useSelector(s => s.geo.cities[`${countryId}.${citySearch}`]) || []
  const selectCity = cityId => {
    setCityId(cityId)
    setRegionId(cities.find(cityInfo => cityInfo.id == cityId).regionId || 0)
  }

  const city = {
    options: cities,
    selected: [cityId],
    onChange: e => selectCity(e.target.value),
    setFilter: setCitySearch,
    filter: citySearch,
  }

  useEffect(() => {
    cities.length || search(citySearch)
  }, [citySearch])

  useEffect(() => {
    if (cities.length == 1) {
      selectCity(cities[0].id)
      nativeSetValue(document.querySelector('[name="cityId"]'), cities[0].id)
    }
  }, [cities])

  return { country, region, city }
}

export { useGeo as default, useGeo, useSimpleGeo }
